import { useSetRecoilState, useRecoilValue } from "recoil"
import { DataRequestResponse } from "./types"
import { chatIdsSelector } from "../recoil/atoms/chats"
import { badgeIdsSelector } from "../recoil/atoms/badges"
import {
  watchPartyHistoryLinksSelector,
  middlewareWatchPartyHistoryLinks
} from "../recoil/atoms/watchPartyHistoryLinks"
import { middlewareStream, streamsAtom } from "../recoil/atoms/streams"
import { badgeHisrotyIdsSelector } from "../recoil/atoms/badgeHistory"
import {
  overlaySelector,
  overlayCallbackSelector,
  showBadgeOverlayAtom
} from "../recoil/atoms/overlay"
import { middlewarePolls, pollsAtom } from "../recoil/atoms/polls"
import { auctionParamsSelector } from "../recoil/atoms/auction"

interface DataRequestProps {
  doStreamConfigUpdateForDataRequest: (resp: DataRequestResponse) => void
  doOverlaysUpdateForDataRequest: (resp: DataRequestResponse) => void
  doProductsUpdateForDataRequest: (resp: DataRequestResponse) => void
  doWatchPartyLinksUpdateForDataRequest: (resp: DataRequestResponse) => void
  doPollsUpdateForDataRequest: (resp: DataRequestResponse) => void
  doAuctionUpdateForDataRequest: (response: DataRequestResponse) => void
  doChatsUpdateForDataRequest: (resp: DataRequestResponse) => void
  // doUsersUpdateForDataRequest: (resp: DataRequestResponse) => void
}

export const useDataRequest = (): DataRequestProps => {
  const setAuctionParams = useSetRecoilState(auctionParamsSelector)
  const setStreamsList = useSetRecoilState(streamsAtom)
  const setEnabledOverlay = useSetRecoilState(showBadgeOverlayAtom)
  const setBadgeHistory = useSetRecoilState(badgeHisrotyIdsSelector)
  const setOverlay = useSetRecoilState(overlaySelector)
  const setBadges = useSetRecoilState(badgeIdsSelector)
  const setPolls = useSetRecoilState(pollsAtom)
  const setWatchPartyHistoryLinks = useSetRecoilState(
    watchPartyHistoryLinksSelector
  )
  const setChats = useSetRecoilState(chatIdsSelector)
  const doStreamConfigUpdateForDataRequest = (resp: DataRequestResponse) => {
    setStreamsList(
      middlewareStream({ type: "DOWNLOAD", payload: resp.streamConfigs })
    )
  }

  const overlayProps = useRecoilValue(overlayCallbackSelector)

  const doOverlaysUpdateForDataRequest = async (resp: DataRequestResponse) => {
    const _overlay = await overlayProps.handleReturnData()
    const findPublishedOverlay = () => {
      if (_overlay === null) {
        if (resp.overlays && resp.overlays.length !== 0) {
          const overlay = resp.overlays.filter(
            item => item.props.published === true
          )[0]?.props
          return overlay
        } else {
          return null
        }
      }
    }
    const dataOverlay = findPublishedOverlay()

    if (_overlay === null) {
      setOverlay(dataOverlay)
      setEnabledOverlay(true)
    }
    const badges = resp.overlays.filter(el => el.props.type === "badge")
    badges.forEach(el => {
      setBadgeHistory({
        name: "ADD",
        badgeHistoryId: el.id,
        badgeHistoryData: el.props
      })
    })
  }

  const doProductsUpdateForDataRequest = (resp: DataRequestResponse) => {
    // Todo: We can remove this listener
    //@ts-ignore
    //TODO need fix type
    setBadges({ name: "RESET" })
    //@ts-ignore
    //TODO need fix type
    setBadges({ name: "ADD", badges: resp.products })
  }

  const doChatsUpdateForDataRequest = (resp: DataRequestResponse) => {
    //@ts-ignore
    //TODO need fix type
    setChats({ type: "DOWNLOAD", payload: { chats: resp.chats } })
  }

  const doWatchPartyLinksUpdateForDataRequest = (resp: DataRequestResponse) => {
    setWatchPartyHistoryLinks(
      middlewareWatchPartyHistoryLinks({
        type: "DOWNLOAD",
        payload: resp.watchPartyConfigs
      })
    )
  }

  const doPollsUpdateForDataRequest = (resp: DataRequestResponse) => {
    const listPolls = resp.polls.map(poll => {
      const options = Object.entries(poll.options).map(el => ({
        choice: el[0],
        vote: el[1]
      }))
      return {
        id: poll.id,
        title: poll.question,
        isVisible: poll.visible,
        totalResponses: poll.totalResponses,
        timestamp: poll.timestamp,
        choices: options,
        author: poll.author
      }
    })

    setPolls(middlewarePolls({ type: "DOWNLOAD_POLLS", payload: listPolls }))
  }

  // done
  const doAuctionUpdateForDataRequest = (response: DataRequestResponse) => {
    const data =
      response.auctions[response.auctions.length - 1]!.ask === undefined &&
      response.auctions[response.auctions.length - 1]!.bid === undefined
        ? {
            ...response.auctions[response.auctions.length - 1],
            ask: response.auctions[response.auctions.length - 1]!.startingPrice
          }
        : response.auctions[response.auctions.length - 1]!.ask === undefined &&
          response.auctions[response.auctions.length - 1]!.bid !== undefined
        ? {
            ...response.auctions[response.auctions.length - 1],
            ask: 0
          }
        : response.auctions[response.auctions.length - 1]
    setAuctionParams(data)
  }
  return {
    doOverlaysUpdateForDataRequest,
    doPollsUpdateForDataRequest,
    doProductsUpdateForDataRequest,
    doStreamConfigUpdateForDataRequest,
    doWatchPartyLinksUpdateForDataRequest,
    doAuctionUpdateForDataRequest,
    doChatsUpdateForDataRequest
    // doUsersUpdateForDataRequest
  }
}
